export default {
  feedback: {
    token_required: 'Rastita valintaruutu vahvistaaksesi, että olet ihminen',
    frequent_requests:
      'Tarkista tekstiviestisi. Olemme jo lähettäneet koodin annettuun numeroon tekstiviestillä. Jos et saanut sitä, tarkista puhelinnumero tai yritä uudelleen 10 minuutin kuluttua.',
  },
};
